import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ICellEditorParams } from 'ag-grid-community';
import { CommonOperationModel, DropdownModel } from '../../models/common.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';



export interface ngMultiselect{
plusIcon:boolean;
  agLabelName:boolean;
}
@Component({
  selector: 'app-ng-multi-select-dropdown',
  templateUrl: './ng-multi-select-dropdown.component.html',
  styleUrls: ['./ng-multi-select-dropdown.component.scss']
})
export class NgMultiSelectDropdownComponent implements OnInit,OnChanges{
  dropdownList = [];
  selectedItems = [];
  
  @Input() dropdownSettings: IDropdownSettings = {}; 
  @Input() dropdownSettings2: any = {};
  public params: ICellEditorParams & ngMultiselect;
  copyUserSelectedBranches: any[]=[];
  @Input() name: string =''; 
  @Input() placeholder: string =''; 
  @Input() id: string =''; 
  @Input() settings: any; 
  @Input() data:  any;
  @Input() isRequired: boolean = false; 
  @Input() branchIds: any[] = []; 
  @Input() editUser: any;
  @Input() labelName:boolean = true;
  @Output() toggleBranchIds:EventEmitter<any[]> = new EventEmitter();
  @Input() getAllDropdownModel : any = {};
  @Input() isShowlable:boolean=true;
  @Input() isclearIcon:boolean = false;
  @Input()  isResetIcon:boolean=false;
  @Output() resetIconClicked: EventEmitter<any> = new EventEmitter<any>();
  value: any;
  values: any;


  ngOnChanges(simpleChanges:SimpleChanges){
    this.copyUserSelectedBranches = JSON.parse(
      JSON.stringify(this.branchIds??[])
    );
  }

   ngOnInit(): void {
      this.dropdownList = [
        { item_id: 1, item_text: 'Mumbai' },
        { item_id: 2, item_text: 'Bangaluru' },
        { item_id: 3, item_text: 'Pune' },
        { item_id: 4, item_text: 'Navsari' },
        { item_id: 5, item_text: 'New Delhi' }
      ];
      this.selectedItems = [
    
      ];
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Select All',
        itemsShowLimit: 2,
        allowSearchFilter: true
      };
    }



    onItemSelect(item: any) {
      var index = this.copyUserSelectedBranches?.findIndex((a) => a?.id == item.id);
      if (index == -1) {
        // var selectedBranchModel: CommonOperationModel = {
        //   id: item.id,
        //   added: true,
        //   deleted: false,
        //   edited: false,
        //   none: false,
        // };
        this.copyUserSelectedBranches?.push({name:item.name});
      } else {
        // if (this.copyUserSelectedBranches[index].deleted == true) {
        //   this.copyUserSelectedBranches[index].none = false;
        //   this.copyUserSelectedBranches[index].edited = true;
        //   this.copyUserSelectedBranches[index].deleted = false;
        //   this.copyUserSelectedBranches[index].added = false;
        //   // this.copyUserSelectedBranches?.push(
        //   //   this.copyUserSelectedBranches[index]
        //   // );
        //   // this.copyUserSelectedBranches?.splice(index, 1);
        // }
      }
      this.toggleBranchIds.emit(this.copyUserSelectedBranches);
  
      console.log('onItemSelect',this.copyUserSelectedBranches);
      console.log(this.branchIds)
   
    }
  
    
  
    // onItemDeSelect(item: any) {
    //   var index = this.copyUserSelectedBranches.findIndex(
    //     (a) => a?.id == item.id
    //   );
    //   this.copyUserSelectedBranches[index].deleted = true;
    //   this.copyUserSelectedBranches[index].added = false;
    //   this.copyUserSelectedBranches[index].none = false;
    //   this.copyUserSelectedBranches[index].edited = false;
    //   this.toggleBranchIds.emit(this.copyUserSelectedBranches)
    //   console.log(this.branchIds)
    // }

    onItemDeSelect(item: any){
      var index = this.copyUserSelectedBranches.findIndex(
            (a) => a?.id == item.id
          );
      this.copyUserSelectedBranches.splice(index,1)
      this.toggleBranchIds.emit(this.copyUserSelectedBranches)
    }
  
    onSelectAll(items: any[]) {
      // items.map(a=>{a.added = true,a.deleted = false,a.none = false,a.edited = false});
      items.map(a => {
        a.added = true;
        a.deleted = false;
        a.none = false;
        a.edited = false;
        if (this.editUser?.branchIds &&  this.editUser.branchIds.some(b => b.id === a.id)) {
          a.edited = true;
          a.added = false;
        }
      });
      
      items.forEach(a=> delete a.name);
      this.copyUserSelectedBranches = items;
      this.toggleBranchIds.emit(this.copyUserSelectedBranches)
      console.log('onItemSelectAll',this.copyUserSelectedBranches);
  
    }
    onItemDeSelectAll(items: any[]) {
      // Ensure editUser and branchIds are defined before proceeding
      if (this.editUser && this.editUser.branchIds) {
        this.copyUserSelectedBranches = this.editUser.branchIds.map(branch => {
          return {
            ...branch,
            added: false,
            deleted: true,
            none: false,
            edited: false
          };
        });
    
        this.toggleBranchIds.emit(this.copyUserSelectedBranches);
      } else {
        console.error("editUser or branchIds is undefined");
        this.clearSelectedItems()
      }
    }

    clearSelectedItems() {
      this.branchIds = []; 
      this.copyUserSelectedBranches = [];   
      this.toggleBranchIds.emit(this.copyUserSelectedBranches);   
  }
    
  }